import { FORTEM_URIS } from '@/constants/uris'
import { SmartradeClientsPage } from '@/pages/smartrade/clients/page'
import { SmartradeDataPage } from '@/pages/smartrade/data/page'
import { SmartradeLayout } from '@/pages/smartrade/layout'
import { SmartradeTradesPage } from '@/pages/smartrade/trades/page'
import type { CustomRouteObject, FortemRouteHandle } from '@/router'

export const smartradeRoutes = [
  {
    path: FORTEM_URIS.SMARTRADE.__INDEX__,
    element: <SmartradeLayout />,
    handle: {
      title: 'Smartrade',
    },
    children: [
      {
        path: FORTEM_URIS.SMARTRADE.TRADES,
        element: <SmartradeTradesPage />,
      },
      {
        path: FORTEM_URIS.SMARTRADE.DATA,
        element: <SmartradeDataPage />,
      },
      {
        path: FORTEM_URIS.SMARTRADE.CLIENTS,
        element: <SmartradeClientsPage />,
      },
    ],
  },
] satisfies CustomRouteObject<FortemRouteHandle>[]
